import { FormEvent } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { resources } from "@constants/hardcoded-strings";
import { ButtonTypes } from "@enums/button-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { ThemingConfigurationContainer } from "@containers/common/theming-configuration-container/theming-configuration-container";
import { ThemingFormContainer } from "@containers/common/theming-form-container/theming-form-container";
import { MessageTemplateVariablesFormSection } from "@containers/message-template-details/message-template-details-component/message-template-variables-tab/message-template-variables-form-section/message-template-variables-form-section";
import { MessageTemplatePreviewContainer } from "@containers/message-template-details/message-template-details-component/message-template-preview-container/message-template-preview-container";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { MessageTemplateVariablesValidationErrors } from "@idw-types/common/validation/message-template/message-template-validation-errors";

type MessageTemplateVariablesFormProps = {
    state: FormattedMessageTemplate;
    requestInProgress: boolean;
    selectedLanguage: LocaleTypes;
    validationErrors: MessageTemplateVariablesValidationErrors;
    setSelectedLanguage: (language: LocaleTypes) => void;
    setState: (state: FormattedMessageTemplate) => void;
    onBackClicked: () => void;
    handleSubmit: (event: FormEvent) => void;
};

export const MessageTemplateVariablesForm = (props: MessageTemplateVariablesFormProps) => {
    const {
        state,
        requestInProgress,
        selectedLanguage,
        validationErrors,
        setSelectedLanguage,
        setState,
        onBackClicked,
        handleSubmit
    } = props;



    const resource = resources.modals.addMessageTemplate;

    return (
        <Form onSubmit={handleSubmit}>
            <Modal.Header id={"add-message-template-title"} closeButton>
                <Modal.Title>{resource.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ThemingConfigurationContainer>
                    <ThemingFormContainer>
                        <MessageTemplateVariablesFormSection
                            isDisabled={false}
                            labelWidth={LabelWidthTypes.MEDIUM}
                            selectedLanguage={selectedLanguage}
                            setMessageTemplateState={setState}
                            setSelectedLanguage={setSelectedLanguage}
                            state={state}
                            validationErrors={validationErrors}
                        />
                    </ThemingFormContainer>
                    <MessageTemplatePreviewContainer
                        state={state}
                        selectedLanguage={selectedLanguage}
                    />
                </ThemingConfigurationContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button id="add-message-template-back-button" variant="secondary" onClick={onBackClicked}>{resources.common.buttons.back.label}</Button>
                <ButtonWithSpinner
                    id="add-message-template-save-button"
                    disabled={requestInProgress || validationErrors.count > 0}
                    hideSpinner={validationErrors.count > 0}
                    variant="primary"
                    type={ButtonTypes.SUBMIT}
                    label={resource.buttons.addMessageTemplate.label}
                />
            </Modal.Footer>
        </Form>
    );
};